import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {TROPHY_SIZE} from "../constants"

interface StyledProps {
  isTrophySelected: boolean
}

const TrophyContainer = styled<StyledProps, "div">("div")`
  width: ${({isTrophySelected}) => (isTrophySelected ? "100%" : `${TROPHY_SIZE}px`)};
  ${minWidthMedia.tablet`
    ${({isTrophySelected}: StyledProps) => isTrophySelected && `
      transition: width 0.5s ease;
    `}
  `}
`

export default TrophyContainer
